export default __webpack_public_path__ + "static/media/pause.4a1092fe.svg";